export function isReturnPath(pathname: string) {
  return pathname.startsWith("/returns") || pathname.startsWith("/member/returns");
}

export function getReturnAwareRoute(pathname: string, returnRoute: string, pickupRoute: string) {
  return isReturnPath(pathname) ? returnRoute : pickupRoute;
}

export function getReturnStoreRoute(isMember: boolean) {
  return isMember ? "/member/returns/store-details" : "/returns/store-details";
}
